import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * HttpInterceptor that adds the Override Parameters to the URL when calling the App Store RSF pod
 */
@Injectable()
export class OverrideParameterInterceptor implements HttpInterceptor {

  private readonly pathsToOverride = ['/as/'];

  private overrideParameters?: { [parameterName: string]: string; };

  constructor() {
  }

  initConfig(overrideParameters: { [parameterName: string]: string; }): void {
    this.overrideParameters = overrideParameters;
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.overrideParameters && this.shouldOverride(request)) {
      request = request.clone({
        params: request.params.appendAll(this.overrideParameters)
      });
    }
    return next.handle(request);
  }

  private shouldOverride(request: HttpRequest<unknown>) {
    return !!this.pathsToOverride.find(
      (endpoint) => request.url.startsWith(endpoint) || request.url.match(`${window.location.hostname}${endpoint}`)
    );
  }

}
